import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Phone, AlertTriangle, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const CALENDLY_URL = 'https://calendly.com/contact-bankkimedia/30min';

export const FinalCTA = () => {
  const { t } = useTranslation();
  const fc = t('home.finalCta', { returnObjects: true });

  return (
    <section data-testid="final-cta" className="py-20 md:py-28 border-t border-white/5 relative overflow-hidden">
      <div className="absolute inset-0"><div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#c8ff00]/5 rounded-full blur-3xl" /></div>
      <div className="container-custom max-w-3xl text-center relative">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-red-500/40 bg-red-500/10 mb-6">
            <AlertTriangle className="w-4 h-4 text-red-400" />
            <span className="text-red-400 text-sm font-bold uppercase tracking-wider">{fc.badge}</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold font-['Syne'] text-white mb-4">{fc.title1}<br />{fc.title2}</h2>
          <p className="text-gray-400 text-lg max-w-xl mx-auto mb-4">{fc.desc}</p>
          <p className="text-white font-bold text-xl mb-8">{fc.pricing}</p>
          <div className="flex flex-wrap justify-center gap-4 mb-4">
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" data-testid="final-cta-btn">
              <motion.span whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }} className="inline-flex items-center gap-2 px-10 py-4 bg-[#c8ff00] text-black font-bold rounded-full text-lg hover:bg-[#d4ff33] transition-colors">
                {fc.cta}
                <ArrowRight className="w-5 h-5" />
              </motion.span>
            </a>
            <a href="tel:+13235777420" className="inline-flex items-center gap-2 px-8 py-4 border border-white/20 text-white font-bold rounded-full hover:bg-white/5 transition-all">
              <Phone className="w-4 h-4" />
              Call: 323-577-7420
            </a>
          </div>
          <p className="text-white/30 text-sm">{fc.subtext}</p>
        </motion.div>
      </div>
    </section>
  );
};

export const LocationsBar = () => (
  <section className="py-12 border-t border-white/5">
    <div className="container-custom">
      <div className="flex flex-wrap justify-center gap-6 text-gray-500 text-sm">
        {['Miami', 'Dubai', 'Montreal', 'Toronto', 'Vancouver', 'Los Angeles'].map(city => (
          <div key={city} className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" />{city}</div>
        ))}
      </div>
    </div>
  </section>
);

export const StickyCTA = () => {
  const { t } = useTranslation();
  const s = t('home.sticky', { returnObjects: true });

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#0a0a0a]/95 backdrop-blur-md border-t border-white/10 py-3 px-4">
      <div className="container-custom flex items-center justify-between gap-4">
        <div className="hidden md:block">
          <p className="text-white font-bold text-sm">{s.title} <span className="text-[#c8ff00]">{s.price}</span></p>
          <p className="text-white/40 text-xs">{s.sub}</p>
        </div>
        <div className="flex items-center gap-3 w-full md:w-auto">
          <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="flex-1 md:flex-none">
            <span className="flex items-center justify-center gap-2 px-6 py-2.5 bg-[#c8ff00] text-black font-bold rounded-full text-sm hover:bg-[#d4ff33] transition-colors w-full">
              {s.cta}
              <ArrowRight className="w-4 h-4" />
            </span>
          </a>
          <a href="tel:+13235777420" className="hidden sm:flex items-center gap-2 px-5 py-2.5 border border-white/20 text-white font-bold rounded-full text-sm hover:bg-white/5 transition-all">
            <Phone className="w-3.5 h-3.5" />
            {s.call}
          </a>
        </div>
      </div>
    </div>
  );
};
